module.exports = __webpack_public_path__ + "images/emoji/bullettrain_front.c8f908dd003c8ce193a6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bullettrain_front.png
// module id = aM9r
// module chunks = 13